// @flow

import { gql } from "@apollo/client";

import { fragments as productionJobLineItemBreakdownFragments } from "../../../../OrderApp/components/ProductQuantitySummary/components/ProductionJobLineItemBreakdown/graph";

export default gql`
  query LocalInventoryOrderDetail($productionJobId: ID!) {
    productionJob: node(id: $productionJobId) {
      ... on OrderProductionJob {
        id
        index
        label
        hasLocalInventorySplit
        customizationAreas {
          id
          location
          method
          directToGarmentAutomatable
          artwork {
            asset {
              url {
                formatted
              }
            }
          }
        }
        proofs: filteredProofs {
          id
          asset {
            url {
              formatted
            }
          }
        }
        order {
          id
          isArtworkApproved
          isResolution
          directToGarmentExpressEligible
          express
          includeCatalogInShipment
          highDefinitionDigitalExpressEligible
          dueBy {
            dateTime
          }
          orderNumber
          primaryCustomer {
            businessUnit {
              id
              name
            }
            id
            insideBrandTagging
            name(format: FIRST_NAME_LAST_NAME)
            status
            totalOrders
          }
          priority
          productionDate
          productionNotesCollection {
            ... on FormattedNote {
              author
              createdAt
              note
            }
            ... on UnformattedNote {
              note
            }
          }
          productionStationAssignments {
            id
            productionStation {
              id
              name
            }
          }
          productionJobs {
            id
            index
            label
            customizationAreas {
              id
              location
              method
              directToGarmentAutomatable
              artwork {
                asset {
                  url {
                    formatted
                  }
                }
              }
            }
            proofs: filteredProofs {
              id
              asset {
                url {
                  formatted
                }
              }
            }
            lineItemBreakdownByProduct {
              product {
                id
                style
              }
              lineItems {
                id
                color {
                  id
                  name
                }
                sizes {
                  id
                  quantity
                  size {
                    id
                    code
                  }
                }
              }
            }
            totalProductVariantQuantity
          }
          productionStationAssignments {
            id
            productionStation {
              id
              name
            }
          }
          shipMissCosts {
            cost {
              formatted
            }
            date
          }
          totalProductVariantQuantity
          totalShippingPrice {
            value
          }
        }
        lineItemBreakdownByProduct {
          product {
            id
            style
            isStyleSubstitution
          }
          ...ProductionJobLineItemBreakdown_productionJobLineItemBreakdown
        }
        totalProductVariantQuantity
      }
    }
  }
  ${productionJobLineItemBreakdownFragments.productionJobLineItemBreakdown}
`;
